/**
 * Borde de error de `/tablet`: la tablet no tiene a nadie que apriete «Recargar». Un error
 * de render o un chunk que no bajó (deploy en el medio, wifi que se cortó) se muestra y a
 * los 10 segundos la tablet se recarga sola.
 */
import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "../../components/ui/Button.js";

export const RELOAD_AFTER_ERROR_MS = 10_000;

const reloadPage = () => window.location.reload();

export function TabletRouteError({ reload = reloadPage }: { reload?: () => void }) {
  const [left, setLeft] = useState(Math.round(RELOAD_AFTER_ERROR_MS / 1000));

  useEffect(() => {
    const timer = window.setTimeout(reload, RELOAD_AFTER_ERROR_MS);
    const tick = window.setInterval(() => setLeft((value) => Math.max(0, value - 1)), 1_000);
    return () => {
      window.clearTimeout(timer);
      window.clearInterval(tick);
    };
  }, [reload]);

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-night px-6 text-center">
      <RefreshCw aria-hidden className="size-7 animate-spin text-accent-live" />
      <h1 className="font-display text-[22px] font-semibold tracking-tight">
        La tablet se está recuperando
      </h1>
      <p className="max-w-[48ch] text-[13px] text-dim" aria-live="polite">
        Algo falló al cargar la pantalla. Se recarga sola en {left} s.
      </p>
      <Button variant="primary" onClick={reload}>
        Recargar ahora
      </Button>
    </div>
  );
}

export default TabletRouteError;
